<template>
  <img
      :src="currentSrc"
      :alt="alt"
      :style="imgStyle"
      @error="onError"
  />
</template>

<script>
export default {
  name: 'ImageWithPlaceholder',
  props: {
    src: String,
    alt: {
      type: String,
      default: ''
    },
    width: {
      type: [Number, String],
      default: null // 默认不传宽度，充满
    },
    height: {
      type: [Number, String],
      default: null // 高度不传则不限制
    }
  },
  data() {
    return {
      currentSrc: this.src || this.getPlaceholder()
    };
  },
  watch: {
    src(newVal) {
      this.currentSrc = newVal || this.getPlaceholder();
    }
  },
  computed: {
    imgStyle() {
      const style = {
        objectFit: 'cover'
      };
      // 宽度处理
      if (this.width === null || this.width === undefined || this.width === '') {
        style.width = '100%'; // 不传宽度时撑满父容器
      } else {
        style.width = typeof this.width === 'number' ? this.width + 'px' : this.width;
      }
      // 高度处理，高度传了才设置
      if (this.height !== null && this.height !== undefined && this.height !== '') {
        style.height = typeof this.height === 'number' ? this.height + 'px' : this.height;
      }
      return style;
    }
  },
  methods: {
    getPlaceholder() {
      const w = this.width === null || this.width === undefined || this.width === '' ? 300 : this.width;
      const h = this.height === null || this.height === undefined || this.height === '' ? 200 : this.height;
      const widthNum = typeof w === 'number' ? w : parseInt(w) || 300;
      const heightNum = typeof h === 'number' ? h : parseInt(h) || 200;
      const text = 'No Image';
      return (
          'data:image/svg+xml;utf8,' +
          encodeURIComponent(`
          <svg width="${widthNum}" height="${heightNum}" xmlns="http://www.w3.org/2000/svg">
            <rect width="${widthNum}" height="${heightNum}" fill="#f0f0f0" />
            <text x="50%" y="50%" dominant-baseline="middle" text-anchor="middle"
                  fill="#999" font-size="18" font-family="Arial, sans-serif">
              ${text}
            </text>
          </svg>
        `)
      );
    },
    onError() {
      this.currentSrc = this.getPlaceholder();
    }
  }
};
</script>
